import Staff from "@/services/staff";

export default {
    data() {
        return {
            isProvider: false,
            isVetsourceProvider: false,
            providers: [],
            vetsourceProviders: []
        };
    },
    methods: {
        async getProvider() {
            Staff.getProviders()
                .then(response => {
                    if (
                        response &&
                        response.resource &&
                        response.resource.data
                    ) {
                        let currentActor = this.$root.currentActor.id;
                        this.isProvider = response.resource.data.find(
                            opt => opt.actor_id === currentActor
                        );

                        if (response.resource.data.length > 0) {
                            this.providers = response.resource.data.map(
                                item => {
                                    return {
                                        id: item.actor_id,
                                        display_name: item.actor.display_name
                                    };
                                }
                            );
                        }
                    } else {
                        throw new Error("Unable to fetch veterinarian list.");
                    }
                })
                .catch(error => {
                    this.isProvider = false;
                    this._message(error.message, "danger");
                });
        },
        async getVetsourceProvider() {
            let self = this;

            this.$http
                .get(
                    process.env.APPS +
                        "index.php/ajax/staff/filter_administrator_veterinarian_sql?source=VETSOURCE"
                )
                .then(function (response) {
                    if (response.data.length > 0) {
                        self.vetsourceProviders = response.data;

                        let currentActor = self.$root.currentActor.id;
                        self.isVetsourceProvider = response.data.some(
                            opt => opt.id === currentActor
                        );
                    }
                });
        }
    }
};
